import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { useEffect, useState, useCallback } from 'react';
import { getHealth } from './api';
import Sidebar from './components/Sidebar';
import Overview from './pages/Overview';
import Trades from './pages/Trades';
import Strategies from './pages/Strategies';
import Scorecard from './pages/Scorecard';
import Config from './pages/Config';
import Logs from './pages/Logs';

function Layout() {
  const [healthy, setHealthy] = useState(false);

  const checkHealth = useCallback(async () => {
    try {
      const res = await getHealth();
      setHealthy(res.status === 'ok');
    } catch {
      setHealthy(false);
    }
  }, []);

  useEffect(() => {
    checkHealth();
    const id = setInterval(checkHealth, 10000);
    return () => clearInterval(id);
  }, [checkHealth]);

  return (
    <div className="flex min-h-screen bg-trader-bg">
      <Sidebar healthy={healthy} />
      <main className="flex-1 p-6 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<Overview />} />
        <Route path="trades" element={<Trades />} />
        <Route path="strategies" element={<Strategies />} />
        <Route path="scorecard" element={<Scorecard />} />
        <Route path="config" element={<Config />} />
        <Route path="logs" element={<Logs />} />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
